import * as React from 'react';
import { colors } from '../../../index';

const IconCircleTwo = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 21",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FCFCFC",
    opacity: 0.147,
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.244 14H8.59v-.649l2.459-2.731c.364-.413.615-.75.753-1.008.139-.258.208-.526.208-.802 0-.37-.113-.675-.337-.912-.224-.238-.523-.356-.897-.356-.45 0-.798.127-1.047.383-.249.255-.373.61-.373 1.065h-.902c0-.653.21-1.182.631-1.585.421-.403.985-.605 1.69-.605.66 0 1.183.173 1.566.52.384.346.576.807.576 1.383 0 .699-.446 1.531-1.337 2.497l-1.902 2.063h3.566V14z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleTwo;